import React from 'react';
import { PropTypes } from 'prop-types';
// logic
import routes from 'utils/routes';
// styles
import styled, { css } from 'styled-components';
import { media } from 'utils/style';
// components
import { Icon } from '@ontruck/orc';
import { OnTruckLogo } from 'refactored/ui/icons';

const BackButtonContainer = styled.div`
  width: 19px;
  svg {
    fill: var(--grey200) !important;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  svg {
    height: 24px;
  }
`;

const LogoButton = ({ className, handleBack, isLoading, ...props }) => {
  const pathname = window.location.pathname;

  //   show back button on all pages that are not in this list
  const pathsWithouthBackButton = [
    routes.orders.active,
    `${routes.emergencies}/`,
  ];

  const showBackButton = !pathsWithouthBackButton.some((path) =>
    pathname.endsWith(path)
  );

  return (
    <button
      {...props}
      disabled={isLoading}
      className={className}
      aria-label="Navigation"
      onClick={handleBack}
    >
      <BackButtonContainer>
        {!isLoading && showBackButton && (
          <span role="img" aria-label="Back">
            <Icon glyph="previous" size="19px" />
          </span>
        )}
      </BackButtonContainer>
      <LogoContainer>
        <OnTruckLogo />
      </LogoContainer>
    </button>
  );
};

LogoButton.propTypes = {
  handleBack: PropTypes.func,
  isLoading: PropTypes.bool,
  className: PropTypes.string,
};

const regularCSS = css`
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
  height: 100%;
  margin-right: auto;
  height: 71px;
  font: inherit;
  cursor: ${(props) => (!!props.isLoading ? 'default' : 'pointer')};
  opacity: 0;
  pointer-events: none;
  svg {
    fill: var(--primary500);
  }
  &:hover {
    ${BackButtonContainer} {
      svg {
        fill: var(--white) !important;
      }
    }
  }
`;

const mobileCSS = css`
  opacity: 1;
  pointer-events: all;
  svg {
    fill: var(--white);
  }
  ${BackButtonContainer} {
    svg {
      fill: var(--white) !important;
    }
  }
`;

const StyledLogoButton = styled(LogoButton)`
  ${regularCSS}
  ${media.lessThan('small')`${mobileCSS}`}
`;

export default StyledLogoButton;
